module.exports = __webpack_public_path__ + "static/media/Dumaszak.3cee3430.png";